import React from "react";

export default function GoldParticles({ count = 40 }) {
  const particles = React.useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: Math.random() * 2.5 + 1.5,
        delay: Math.random() * 18,
        duration: 16 + Math.random() * 18,
        opacity: Math.random() * 0.35 + 0.15,
        color: Math.random() > 0.5 ? "#D4A88E" : "#C8D2BD",
      })),
    [count]
  );
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      {particles.map((p) => (
        <span
          key={p.id}
          style={{
            position: "absolute",
            left: `${p.left}%`,
            bottom: `-10px`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            background: p.color,
            borderRadius: "50%",
            opacity: p.opacity,
            filter: "blur(0.5px)",
            boxShadow: `0 0 6px ${p.color}80`,
            animation: `float-up ${p.duration}s linear ${p.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
}
